/* eslint-env browser */
module.exports = window.FormData;
